<template>
  <div class="main-content-container">
    <div class="container">
      <!-- Page Header -->
      <div class="page-header row no-gutters py-4">
        <div class="col-6 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">sessão</span>
          <h3 class="page-title">Detalhes da Conta Corrente</h3>
        </div>
        <!-- Page Header - Filters -->
        <div class="col-6 d-flex">
          <div class="input-group d-flex justify-content-end my-auto"></div>
        </div>
      </div>
      <d-row>
        <!-- Cards -->
        <d-col
          v-for="(card, index) in Cards"
          :key="index"
          md="4"
          lg="4"
          class="mb-4"
        >
          <cards
            :id="`card-${index}`"
            :label="card.label"
            :link="card.link"
            :title="card.title"
            :small="true"
            :value="card.value"
          />
        </d-col>
      </d-row>

      <!-- Default Light Table -->
      <div class="row">
        <div class="col" lg="2" style="max-width: 225px">
          <div class="list-group dados-list">
            <a
              class="list-group-item active"
              style="cursor: pointer"
              data-toggle="tab"
              v-on:click="FilterPaymentMethod('T')"
            >
              <i class="item-icon fas fa-money-check-alt"></i>
              <span class="item-title">Todos</span>
            </a>
            <a
              class="list-group-item"
              style="cursor: pointer"
              data-toggle="tab"
              v-on:click="FilterPaymentMethod('1')"
            >
              <i class="item-icon fas fa-tag"></i>
              <span class="item-title">Boleto</span>
            </a>
            <a
              class="list-group-item"
              style="cursor: pointer"
              data-toggle="tab"
              v-on:click="FilterPaymentMethod('2')"
            >
              <i class="item-icon fas fa-credit-card"></i>
              <span class="item-title">Crédito</span>
            </a>
            <a
              class="list-group-item"
              style="cursor: pointer"
              data-toggle="tab"
              v-on:click="FilterPaymentMethod('3')"
            >
              <i style="font-size: 17px" class="fab fa-btc"></i>
              <span class="item-title">Criptomoedas</span>
            </a>
            <a
              class="list-group-item"
              style="cursor: pointer"
              data-toggle="tab"
              v-on:click="FilterPaymentMethod('4')"
            >
              <i class="item-icon fas fa-credit-card"></i>
              <span class="item-title">Débito</span>
            </a>
            <a
              class="list-group-item"
              style="cursor: pointer"
              data-toggle="tab"
              v-on:click="FilterPaymentMethod('O')"
            >
              <i class="item-icon fas fa-money-check-alt"></i>
              <span class="item-title">Outros</span>
            </a>
          </div>

          <div class="card card-small" style="margin-top: 20px;">
            <div class="list-group-item">
              <label class="m-0">Status do Repasse</label>
              <h5
                class="item-title"
                style="text-align:center"
                v-if="
                  this.infoDetails.TransferStatus != null &&
                  this.infoDetails.TransferStatus != undefined &&
                  (this.infoDetails.TransferStatus.Code == '4' ||
                    this.infoDetails.TransferStatus.Code == '5')
                "
              >
                Repasse não efetivado
              </h5>
              <h5 class="m-0" style="text-align:center" v-else>
                {{ this.infoDetails.Message }}
              </h5>
            </div>
          </div>
        </div>

        <div class="col" lg="10">
          <div class="card card-small mb-4">
            <div class="card-header border-bottom">
              <b-row align-h="between">
                <b-col cols="5">
                  <button
                    class="btn button-arrow"
                    type="button"
                    v-on:click="AlterDay(true)"
                    title="Dia anterior"
                  >
                    <i class="fas fa-chevron-left"></i>
                  </button>
                </b-col>
                <d-col cols="2">
                  <h5>{{ this.$options.filters.date(this.filter.InitialDate) }} </h5>
                </d-col>
                <b-col cols="5" class="d-flex justify-content-end">
                  <div>
                    <button
                      class="btn text-right button-arrow-right"
                      style="width: 40px"
                      type="button"
                      title="Próximo dia"
                      v-on:click="AlterDay(false)"
                    >
                      <i class="fas fa-chevron-right"></i>
                    </button>
                  </div>
                </b-col>
              </b-row>
              <b-row align-h="between" class="mt-3">
                <b-col cols="6">
                  <h6 class="m-0">Recebimentos</h6>
                </b-col>
                <b-col cols="6" class="d-flex justify-content-end">
                  <b-input-group
                    class="d-flex justify-content-end my-auto ml-2"
                  >
                    <h6 v-if="pagination.TotalItems > 0" class="m-0">
                      {{ pagination.TotalItems | number }}
                      {{ pagination.TotalItems > 1 ? " itens" : "item" }}
                    </h6>
                    <div class="dropdown m-0" v-if="pagination.TotalItems > 1">
                      <button
                        class="btn btn-outline-secondary dropdown-toggle-ellipsis"
                        type="button"
                        v-b-tooltip.hover.right
                        title="Mais opções"
                        id="dropdownMenuButton"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        <i class="fas fa-ellipsis-v"></i>
                      </button>
                      <div
                        class="dropdown-menu"
                        id="dropTableOptions"
                        aria-labelledby="dropdownMenuButton"
                      >
                        <a
                          class="dropdown-item"
                          href="#"
                          :class="loadingReport ? 'disabled' : ''"
                          v-on:click.stop="GetReport($event)"
                        >
                          <template v-if="loadingReport">
                            <loader
                              :small="true"
                              :isLoading="loadingReport"
                            ></loader>
                          </template>
                          <template v-else>
                            <i class="fas fa-check mr-2"></i>
                            Gerar relatório
                          </template>
                        </a>
                      </div>
                    </div>
                  </b-input-group>
                </b-col>
              </b-row>
            </div>
            <div class="card-body p-0 pb-3 text-center">
              <loader :is-loading="loadingList"></loader>
              <table class="table mb-0" v-if="!loadingList">
                <thead class="bg-s2p-gray-light">
                  <tr>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0 text-left">Descrição</th>
                    <th scope="col" class="border-0">Referência</th>
                    <th scope="col" class="border-0">Valor líquido</th>
                    <th scope="col" class="border-0">Método de pagamento</th>
                    <th scope="col" class="border-0">Parcela</th>
                    <th scope="col" class="border-0"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(checkingAccount, index) in checkingAccounts"
                    :key="index"
                  >
                    <td></td>
                    <td class="text-left td-span-style">
                      {{ checkingAccount.Description }}
                    </td>
                    <td>{{ checkingAccount.Reference }}</td>
                    <td>{{ checkingAccount.Amount | currency }}</td>
                    <td>{{ checkingAccount.PaymentMethod.Name }}</td>
                    <td>
                      {{ checkingAccount.InstallmentNumber }}/{{
                        checkingAccount.InstallmentQuantity
                      }}
                    </td>
                    <td></td>
                  </tr>
                  <tr
                    v-if="
                      checkingAccounts == undefined ||
                      checkingAccounts == null ||
                      checkingAccounts.length == 0
                    "
                  >
                    <td colspan="7">Sem registros</td>
                  </tr>
                </tbody>
              </table>

              <div class="col-12 border-top">
                <div class="pagination-nav">
                  <b-pagination
                    class="float-right"
                    v-model="pagination.PageNumber"
                    :total-rows="pagination.TotalItems"
                    :per-page="pagination.RowsPerPage"
                    aria-controls="my-table"
                  ></b-pagination>
                  <div class="float-left">
                    <d-select size="sm" v-model="pagination.RowsPerPage">
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="30">30</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="200">200</option>
                      <option value="500">500</option>
                    </d-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <a
      href="#"
      class="btn-float btn-primary"
      v-show="showBtnScroll"
      v-on:click="ScrollToTop($event)"
    >
      <i class="fa fa-chevron-up"></i>
    </a>
  </div>
</template>

<script>
import cards from "@/components/common/cards";
export default {
  name: "checking-account-details",
  data: function () {
    return {
      checkingAccounts: [],
      filter: {
        CodePaymentMethod: null,
        InitialDate: this.$route.query.initialDate,
        TypeFilter: null,
        IdMerchant:
          this.$route.params.idMerchant != null &&
          this.$route.params.idMerchant !== undefined
            ? this.$route.params.idMerchant
            : null,
      },
      infoDetails: {
        TotalAmountDay: 0,
        TotalChargeback: 0,
        TotalTax: 0,
        TotalAcquirerTax: 0,
      },
      loadingList: false,
      loadingReport: false,
      pagination: {
        PageNumber: 1,
        RowsPerPage: 10,
        TotalItems: 0,
      },
      showBtnScroll: false,
    };
  },
  components: {
    cards,
  },
  computed: {
    Cards() {
      return [
        {
          label: "Total de recebíveis",
          value: this.$options.filters.currency(
            this.infoDetails.TotalAmountDay
          ),
        },
        {
          label: "Total de taxas",
          value: this.$options.filters.currency(this.infoDetails.TotalTax),
        },
        {
          label: "Total de estornos",
          value: this.$options.filters.currency(
            this.infoDetails.TotalChargeback
          ),
        },
      ];
    },
  },
  watch: {
    "pagination.PageNumber": function () {
      this.ListPeriod();
    },
    "pagination.RowsPerPage": function () {
      this.ListPeriod();
    },
  },
  created() {
    window.addEventListener("scroll", this.HandleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.HandleScroll);
  },
  mounted() {
    this.ListPeriod();
  },
  methods: {
    HandleScroll: function () {
      if (
        document.body.scrollTop > 120 ||
        document.documentElement.scrollTop > 120
      ) {
        this.showBtnScroll = true;
      } else {
        this.showBtnScroll = false;
      }
    },
    ScrollToTop: function () {
      window.scrollTo(0, 0);
    },
    FilterPaymentMethod: function (code) {
      if (code === "T" || code === "O") {
        this.filter.TypeFilter = code;
        this.filter.CodePaymentMethod = null;
      } else {
        this.filter.TypeFilter = null;
        this.filter.CodePaymentMethod = code;
      }
      this.ListPeriod();
    },
    GetReport: function (ev) {
      ev.preventDefault();
      this.loadingReport = true;
      const params = {
        InitialDate: this.filter.InitialDate,
        "PaymentMethod.Code": this.filter.CodePaymentMethod,
        TypeFilter: this.filter.TypeFilter,
        "Object.Merchant.Id": this.filter.IdMerchant,
      };
      this.$store
        .dispatch("ReportCheckingAccountPeriod", { params: params })
        .then((response) => {
          if (
            response.UrlReport != null &&
            response.UrlReport != undefined &&
            response.UrlReport != ""
          ) {
            this.$makeToast(
              "Aguarde a conclusão do download",
              "info",
              "Relatório gerado com sucesso"
            );
            window.open(response.UrlReport, "_self");
          }
        })
        .catch((error) => {
          this.$makeToast(
            "Tente novamente mais tarde.",
            "danger",
            "Erro ao gerar o relatório",
            error
          );
        })
        .finally(() => {
          $("#dropTableOptions").dropdown("hide");
          setTimeout(() => {
            this.loadingReport = false;
          }, 1200);
        });
    },
    AlterDay: function (prev) {
      let date = new Date(this.filter.InitialDate);
      this.filter.InitialDate = prev
        ? this.$options.filters.addDay(date, -1)
        : this.$options.filters.addDay(date, 1);
      this.ListPeriod();
    },
    ListPeriod: function () {
      this.ResetInfoDetails();
      this.loadingList = true;
      let data = {
        ...this.pagination,
        ...{
          InitialDate: this.filter.InitialDate,
          TypeFilter: this.filter.TypeFilter,
          "PaymentMethod.Code": this.filter.CodePaymentMethod,
          "Object.Merchant.Id": this.filter.IdMerchant,
        },
      };
      this.$store
        .dispatch("ListCheckingAccountPeriod", { params: data })
        .then((response) => {
          this.infoDetails = response;
          this.checkingAccounts = response.Objects;
          this.pagination.TotalItems = response.TotalItems;
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao carregar os detalhes da conta corrente",
            error
          );
        })
        .finally(() => (this.loadingList = false));
    },
    ResetInfoDetails: function () {
      this.infoDetails = {
        TotalAmountDay: 0,
        TotalTax: 0,
        TotalChargeback: 0,
        TotalAcquirerTax: 0,
        CheckingAccounts: [],
      };
    },
  },
};
</script>

<style scoped>
.item-icon {
  font-size: 17px;
}
.item-title {
  margin-left: 10px;
}
.td-span-style {
  font-size: 9pt;
  opacity: 0.75;
}
.dados-list > .active {
  color: white;
}
.dados-list > .list-group-item:hover {
  background: #00304df0;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/MerchantCheckingAccountDetail.vue